import {
  AccountInput,
  Maybe,
  VerticalID,
  Operation,
} from '../../../__generated__/globalTypes'

import {
  AccountFragment,
  accountFragmentString,
} from '../../fragments/__generated__/AccountFragment'

import { minimalSponsorFragmentString } from '../../fragments/__generated__/MinimalSponsorFragment'

import { stripeSubscriptionString } from '../../fragments/__generated__/StripeSubscription'

import { subscriptionMetadataString } from '../../fragments/__generated__/SubscriptionMetadata'

import { amountString } from '../../fragments/__generated__/Amount'

import { stripeSourceFragmentString } from '../../fragments/__generated__/StripeSourceFragment'

import { planFragmentString } from '../../fragments/__generated__/PlanFragment'

import { creditCardFragmentString } from '../../fragments/__generated__/CreditCardFragment'

import { subscriptionFeaturesString } from '../../fragments/__generated__/SubscriptionFeatures'

import { planFeatureFragmentString } from '../../fragments/__generated__/PlanFeatureFragment'

import { userSettingsFragmentString } from '../../fragments/__generated__/UserSettingsFragment'

import { expenseReloadString } from '../../fragments/__generated__/ExpenseReload'

import { bankAccountFragmentString } from '../../fragments/__generated__/BankAccountFragment'

import { addressFragmentString } from '../../fragments/__generated__/AddressFragment'

import { planFeatureIconString } from '../../fragments/__generated__/PlanFeatureIcon'

import { featureFragmentString } from '../../fragments/__generated__/FeatureFragment'

import { storefrontString } from '../../fragments/__generated__/Storefront'

import createAccountRawString from '../CreateAccount.graphql'

const createAccountString = [
  createAccountRawString,
  accountFragmentString,
  minimalSponsorFragmentString,
  stripeSubscriptionString,
  subscriptionMetadataString,
  amountString,
  stripeSourceFragmentString,
  planFragmentString,
  creditCardFragmentString,
  subscriptionFeaturesString,
  planFeatureFragmentString,
  userSettingsFragmentString,
  expenseReloadString,
  bankAccountFragmentString,
  addressFragmentString,
  planFeatureIconString,
  featureFragmentString,
  storefrontString,
].join('\n\n')

export type CreateAccountData = {
  createAccount: {
    account: AccountFragment
  }
}

export type CreateAccountVariables = {
  account: AccountInput
  verticalId?: Maybe<VerticalID>
}

export type CreateAccount = Operation<CreateAccountData, CreateAccountVariables>

export const CreateAccount = ({
  account,
  verticalId,
}: CreateAccountVariables): CreateAccount => ({
  query: createAccountString,
  variables: {
    account: AccountInput(account),
    verticalId,
  },
})
